import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@material-ui/core/styles';
import { displayFilterList } from 'constants/resources/commonCustomize';

import { setPortal } from 'modules/portal';
import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import { userOnLogin } from 'lib/api/user';
import { campaignCtrList, campaignManageImgList } from 'lib/api/campaign';

import Icon from 'components/atoms/Icon';
import NewButton from 'components/molecules/NewButton';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import SpanningTableContents from 'components/molecules/MbTable/SpanningTableContents';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';
import SnackbarWrap from 'components/organisms/Snackbar/SnackbarWrap';
import NewTableContainer from 'components/molecules/NewTable';

import Modal from './Modal';

const Ctr = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));
  const dispatch = useDispatch();

  const [initialization, setInitialization] = useState(false);
  const initParams = {
    sort: 'desc',
    order: 'CONTACT_NAME',
    sDate: moment().format('YYYYMM01'),
    eDate: moment().format('YYYYMMDD'),

    advrtsPrdtCode: '07',
    advrtsTpCode: '01',
    state: 'all', // 게재상태
    image: 'all', // 이미지 등록여부
    campDesc: 'all', // 캠페인공통설명
    changeState: 'all', // 변경상태필터
    contact: 'all',
  };
  const [params, setParams] = useState(initParams);

  const initList = {
    state: [
      // 게재상태
      { label: '전체 게재중', value: 'all' },
      { label: '중지', value: '01' },
    ],
    image: [
      // 이미지 등록여부
      { label: '전체', value: 'all' },
      { label: '등록', value: '01' },
      { label: '미등록', value: '02' },
    ],
    campDesc: [
      // 캠페인공통설명
      { label: '전체', value: 'all' },
      { label: '등록', value: '01' },
      { label: '미등록', value: '02' },
    ],

    changeState: [
      // 변경상태필터
      { label: '전체', value: 'all' },
      { label: '수정 후 10일 경과 전', value: '01' },
      { label: '수정 10일 경과 후 성과 ↓', value: '02' },
      { label: '수정 10일 경과 후 성과 ↑', value: '03' },
    ],
  };
  const [list] = useState(initList);

  const initSnackbar = {
    open: false,
    variant: '',
    message: '',
  };
  const [snackbar, setSnackbar] = useState(initSnackbar);
  const initModal = {
    open: false,
    type: null,
    params: {},
    data: [],
  };
  const [modal, setModal] = useState(initModal);

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  /**
   * 페이지 파라미터를 관리하는 params을 수정하는 함수
   * @param newParams
   */
  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    LAST_DATE: {
      makeBody: (rowObj, headsMap) => {
        return rowObj['LAST_DATE'];
      },
    },
    W_STATE: {
      makeBody: (rowObj, headsMap) => {
        return (
          <Icon
            icon="faPowerOff"
            style={
              rowObj.W_STATE === '01'
                ? { color: '#79bd2f' }
                : { color: '#6d6d6d' }
            }
          />
        );
      },
    },
    M_STATE: {
      makeBody: (rowObj, headsMap) => {
        return (
          <Icon
            icon="faPowerOff"
            style={
              rowObj.M_STATE === '01'
                ? { color: '#79bd2f' }
                : { color: '#6d6d6d' }
            }
          />
        );
      },
    },
    IMG_URL: {
      makeHead: (headsMap) => {
        return <>이미지</>;
      },
      makeBody: (rowObj, headsMap) => {
        return (
          !!rowObj['IMG_URL'] && (
            <NewButton
              title={t('전체이미지')}
              icon="faImages"
              iconBtn
              onClick={(e) => handleModalOpen(rowObj['SITE_CODE'])}
              disableRipple
              style={{ backgroundColor: '#79bd2f' }}
              color="#fff"
            />
          )
        );
      },
    },
    CAMP_DESC_STR: {
      makeBody: (rowObj, headsMap) => {
        let texts = '';
        let result = [];
        if (rowObj['CAMP_DESC_STR'] !== null) {
          texts = rowObj['CAMP_DESC_STR'].split('||');
          result = (
            <IconAreaWrap
              text={texts.map((text, index) => {
                return (
                  <span key={index}>
                    {text}
                    <br />
                  </span>
                );
              })}
              icon="faSignInAlt"
              toolTipTitle={t('광고주 로그인')}
              onClick={(e) => handleOnLogin(rowObj)}
            />
          );
        } else {
          texts = rowObj['CAMP_DESC_STR'];
          result = t('설명 없음');
        }
        return result;
      },
      headStyle: { width: 400 },
    },
    PAR_EPRS_CNT: {
      makeHead: (headsMap) => {
        return (
          <SpanningTableContents topTitle={t('캠페인 CTR')} type={'head'}>
            <div style={{ width: 50 }}>노출수</div>
            <div style={{ width: 50 }}>클릭수</div>
            <div style={{ width: 50 }}>CTR</div>
            <div style={{ width: 50 }}>세션전환단가</div>
            <div style={{ width: 50 }}>차이</div>
          </SpanningTableContents>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'PAR_EPRS_CNT');
        const bodyItem2 = getHeadObj(headsMap, 'CLICK_CNT');
        const bodyItem3 = getHeadObj(headsMap, 'CLICK_RATE');
        const bodyItem4 = getHeadObj(headsMap, 'SESSION_CONV_AMT');
        const bodyItem5 = getHeadObj(headsMap, 'RAF_DIFF_CLICK_RATE');
        const rafColor =
          rowObj['RAF_DIFF_CLICK_RATE'] > 200
            ? theme.palette.table.cell.red
            : theme.palette.table.cell.blue;
        return (
          <SpanningTableContents>
            <div style={{ width: 50, color: theme.palette.table.cell.black }}>
              {makeRowColumn(
                rowObj['PAR_EPRS_CNT'],
                bodyItem1.type,
                bodyItem1.format
              )}
            </div>
            <div style={{ width: 50, color: theme.palette.table.cell.black }}>
              {makeRowColumn(
                rowObj['CLICK_CNT'],
                bodyItem2.type,
                bodyItem2.format
              )}
            </div>
            <div style={{ width: 50, color: theme.palette.table.cell.blue }}>
              {makeRowColumn(
                rowObj['CLICK_RATE'],
                bodyItem3.type,
                bodyItem3.format
              )}
            </div>
            <div style={{ width: 50, color: theme.palette.table.cell.red }}>
              {makeRowColumn(
                rowObj['SESSION_CONV_AMT'],
                bodyItem4.type,
                bodyItem4.format
              )}
            </div>
            <div style={{ width: 50, color: rafColor }}>
              {makeRowColumn(
                rowObj['RAF_DIFF_CLICK_RATE'],
                bodyItem5.type,
                '#,###%'
              )}
            </div>
          </SpanningTableContents>
        );
      },
      headStyle: {
        borderLeft: '1px solid #e5e8eb',
        borderRight: '1px solid #e5e8eb',
      },
      bodyStyle: {
        borderLeft: '1px solid #e5e8eb',
        borderRight: '1px solid #e5e8eb',
      },
      orderFlag: false,
    },
    CLICK_CNT: { merged: true },
    CLICK_RATE: { merged: true },
    SESSION_CONV_AMT: { merged: true },
    RAF_DIFF_CLICK_RATE: { merged: true },
    CAMP_ADVRTS_AMT: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'CAMP_ADVRTS_AMT');
        return (
          <span style={{ color: theme.palette.table.cell.red }}>
            {makeRowColumn(
              rowObj['CAMP_ADVRTS_AMT'],
              bodyItem1.type,
              bodyItem1.format
            )}
          </span>
        );
      },
    },
    ADVER_BDGT_AMT: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'ADVER_BDGT_AMT');
        return (
          <span style={{ color: theme.palette.table.cell.red }}>
            {makeRowColumn(
              rowObj['ADVER_BDGT_AMT'],
              bodyItem1.type,
              bodyItem1.format
            )}
          </span>
        );
      },
    },
    CAMP_BDGT_AMT: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'CAMP_BDGT_AMT');
        return (
          <span style={{ color: theme.palette.table.cell.red }}>
            {makeRowColumn(
              rowObj['CAMP_BDGT_AMT'],
              bodyItem1.type,
              bodyItem1.format
            )}
          </span>
        );
      },
    },
    W_URL: {
      makeBody: (rowObj, headsMap) => {
        let stateColor = '#000';
        if (!!rowObj['W_URL']) {
          stateColor = '#f00';
        }
        return !!rowObj['W_URL'] ? (
          <NewButton
            title={t('사이트로 이동')}
            iconBtn
            icon="faHome"
            disableRipple
            onClick={(e) => handlePortalUrl(rowObj['W_URL'])}
          />
        ) : (
          <span style={{ color: stateColor }}>미등록</span>
        );
      },
    },
    M_URL: {
      makeBody: (rowObj, headsMap) => {
        let stateColor = '#000';
        if (!!rowObj['M_URL']) {
          stateColor = '#f00';
        }
        return !!rowObj['M_URL'] ? (
          <NewButton
            title={t('사이트로 이동')}
            iconBtn
            icon="faHome"
            disableRipple
            onClick={(e) => handlePortalUrl(rowObj['M_URL'])}
          />
        ) : (
          <span style={{ color: stateColor }}>미등록</span>
        );
      },
    },
    SITE_CODE: { merged: true },
    ADVER_ID: { merged: true },
  };

  /**
   * modal 열어주는 함수
   */
  const handleModalOpen = (data) => {
    let newModal = { ...initModal };
    campaignManageImgList({ siteCode: data })
      .then((response) => {
        const { data } = response.data;
        newModal = {
          ...newModal,
          open: true,
          data: data,
        };
      })
      .catch((error) => {
        setSnackbar({
          ...initSnackbar,
          open: true,
          variant: 'error',
          message: error,
        });
      })
      .finally(() => {
        setModal({
          ...newModal,
        });
      });
  };

  /**
   * 로그인처리
   */
  const handleOnLogin = (rowData) => {
    userOnLogin(
      rowData['ADVER_ID'],
      'manage',
      'https://manage.mobon.net/advertiser/form?' +
        'siteCode=' +
        rowData['SITE_CODE'] +
        '&svcType=' +
        params.advrtsPrdtCode
    )
      .then((response) => {
        const { data, success } = response.data;
        if (success) {
          handlePortalUrl(data.url);
        } else {
          alert('로그인에 실패했습니다. 관리자에게 문의하세요.');
        }
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  /**
   * 모달 닫아주는 함수
   */
  const handleModalClose = () => {
    let newModal = { ...modal };
    newModal = {
      ...newModal,
      open: false,
    };
    setModal(newModal);
  };

  /**
   * 모달에 submit 버튼을 눌렀을 때 실행되는 함수
   */
  const handleSubmit = () => {
    setModal(initModal);
  };

  /**
   * 스낵바 닫는 함수
   * 연속 클릭이 들어왔을 때는 기존 스낵바를 유지
   * @param event
   * @param reason
   */
  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar(initSnackbar);
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          usePltfomTpCodeFilter={false}
          useExternalFilter={false}
          useManagerFilter
          pltfomTpCodeDetailFilter={['03', '04']}
          displayFilterList={displayFilterList.campaign.ctr}
          required={{
            type: 'DisplayFilter',
            val: ['advrtsPrdtCode', 'advrtsTpCode'],
          }}
          useDisplayAll={false}
          onlyProducts
        />
        <FilterCollection
          label={t('게재상태')}
          name="state"
          params={params}
          value={params.state}
          type="radio"
          list={list.state}
          callBack={getParam}
          labelKey="label"
          valueKey="value"
        />
        <FilterCollection
          label={t('이미지')}
          name="image"
          params={params}
          value={params.image}
          type="radio"
          list={list.image}
          callBack={getParam}
          labelKey="label"
          valueKey="value"
        />
        <FilterCollection
          label={t('이벤트 공통 설명')}
          name="campDesc"
          params={params}
          value={params.campDesc}
          type="radio"
          list={list.campDesc}
          callBack={getParam}
          labelKey="label"
          valueKey="value"
        />
        <FilterCollection
          label={t('상태필터')}
          name="changeState"
          params={params}
          value={params.changeState}
          type="radio"
          list={list.changeState}
          callBack={getParam}
          labelKey="label"
          valueKey="value"
        />
      </NewFilterWrap>

      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={campaignCtrList}
        customized={customized}
        useFetch={false}
        rowsPerPage={50}
        // rowsPerPageOptions={[50, 100, 500, 1000, { label: 'All', value: -1 }]}
        useTotal={false}
      />

      <Modal
        modal={modal}
        handleSubmit={handleSubmit}
        handleModalClose={handleModalClose}
      />
      <SnackbarWrap
        open={snackbar.open}
        variant={snackbar.variant}
        message={snackbar.message}
        onClose={handleSnackBarClose}
      />
    </>
  );
};

export default Ctr;
